import {EventEmitter, Injectable, Output} from '@angular/core';
import {AbstractActionSheet} from '../../../../../shared/components/action-sheet/abstract';

/**
 * Class for the ImageShortcodeToolbarActionSheetComponent
 * @class
 */
@Injectable()
export class ImageShortcodeToolbarActionSheet extends AbstractActionSheet {

  @Output()
  onUpload: EventEmitter<any> = new EventEmitter();

  @Output()
  onSearch: EventEmitter<any> = new EventEmitter();

  /** @inheritdoc */
  present(opts: object, status: string = null) {
    return super.present(Object.assign({
      buttons: this.getButtons(),
      cssClass: 'image-shortcode-toolbar-action-sheet',
      enableBackDropDismiss: true,
    }, opts), status);
  }

  /**
   * Get the buttons for this action sheet
   * @protected
   * @returns {any}
   */
  protected getButtons(): any {
    return [
      {
        handler: () => this.onSearch.emit(),
        icon: 'search',
        text: 'Search',
        cssClass: 'search-button',
      },
      {
        handler: () => this.onUpload.emit(),
        icon: 'cloud-upload',
        text: 'Upload',
        cssClass: 'upload-button',
      },
      {
        icon: 'close',
        text: 'Cancel',
        cssClass: 'close-button',
      },
    ];
  }

}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/action-sheet/image-shortcode-toolbar/image-shortcode-toolbar-action-sheet.component.ts